import Intro from "./Intro";
import Socials from "./Socials";

import anim from "./Selected-work/hyperadapt.png";
import anim2 from "./Selected-work/balanced_norm_optimizer.gif";
import anim3 from "./Selected-work/comp_22.gif";

const anims = [anim, anim2, anim3];
const imgTitles = [
  "HyperAdapt: Simple High-Rank Adaptation",
  "Norm Balancing Optimizers",
  "Finding Cell Fate Trajectory",
];
const workLinks = [
  "https://arxiv.org/abs/2509.18629v2",
  "https://www.sarthakmangla.com/blog/bam",
  "https://www.biorxiv.org/content/10.1101/2024.06.25.600667v1.abstract",
];

function Home() {
  return (
    <div className="space-y-3">
      <div className="flex flex-col md:grid md:grid-cols-12 md:items-center pt-3 md:py-[3rem]   ">
        <div className="col-span-12 md:col-span-4">
          <Socials />
        </div>
        <div className="col-span-12 md:col-span-8 text-base md:text-xl">
          <Intro />
        </div>
      </div>
      <div>
        <h1 className="font-[400] p-4">Selected Works</h1>
        <div className="flex justify-center">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 justify-around text-sm">
            {anims.map((src, index) => (
              <div
                key={index}
                className="space-y-2 border border-[#d4d4d4] bg-[#fefefe] shadow h-[20rem] rounded-md transition-transform duration-300 hover:scale-110"
                onClick={() => window.open(workLinks[index], "_blank")}
                style={{ cursor: "pointer" }}
              >
                {src === anim ? (
                  <p className="text-center mt-2">
                    {" "}
                    Outstanding Paper Award at NeurIPS CCFM Workshop 🏆
                  </p>
                ) : (
                  <p className="mt-2">
                    {" "}
                    <br />
                  </p>
                )}
                <img src={src} className="mx-auto h-[15rem]" />

                <p className="font-libre text-center px-4">
                  {" "}
                  {imgTitles[index]}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
